import { GrButton } from "@jnpmedi/grebob";
import { handleDownloadUrlResponse } from "@newLibs/converting";
import { MvnMessage } from "@newLibs/utils";
import { notify } from "@newHooks/context/snackbar/notify";
import { useDownloadFolderFileMutation } from "@newHooks/mutation/folderFile/downloadFolderFile.mutation";
import { useDownloadFolderFileBySharingLinkMutation } from "@newHooks/mutation/folderSharing/downloadFolderFileDocsPdfPageBySharingLink.mutation";
import { DOCS_DOCUMENT_LANG } from "@maven-msg/lang/docs";
import { DOCS_COMMON_LANG } from "@maven-msg/lang/docs/common";

export function FileDownloadButton({ fileId, accessToken }: { fileId: bigint; accessToken?: string }) {
  const { mutate: downloadFileRequest, isLoading: isDownloadFileLoading } = useDownloadFolderFileMutation({
    onSuccess: (data) => {
      if (!data.url) {
        notify(MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_FAIL, { message: "Empty URL" }), "WARN");
        return;
      }

      handleDownloadUrlResponse(data.url);
      notify(MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_SUCC), "SUCC");
    },
    onError: (error) => {
      notify({ message: MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_FAIL, { message: error.responseMessage }), severity: "warning" });
    },
  });

  const { mutate: downloadFileBySharingLinkRequest, isLoading: isDownloadFileBySharingLinkLoading } =
    useDownloadFolderFileBySharingLinkMutation(
      { fileId },
      {
        onSuccess: (data) => {
          if (!data.url) {
            notify(MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_FAIL, { message: "Empty URL" }), "WARN");
            return;
          }

          handleDownloadUrlResponse(data.url);
          notify(MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_SUCC), "SUCC");
        },
        onError: (error) => {
          notify(MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_DOWNLOAD_FAIL, { message: error.responseMessage }), "WARN");
        },
      }
    );

  const handleFileDownload = () => {
    if (isDownloadFileLoading || isDownloadFileBySharingLinkLoading) return;

    if (accessToken) {
      downloadFileBySharingLinkRequest({ fileId, accessToken });
    } else {
      downloadFileRequest({ fileId });
    }
  };

  return (
    <GrButton
      type="button"
      color="grey"
      variant="outlined"
      startIcon="arrow-bar-to-down"
      startIconSize={12}
      disabled={isDownloadFileLoading || isDownloadFileBySharingLinkLoading}
      onClick={handleFileDownload}
    >
      {MvnMessage(DOCS_COMMON_LANG.DOWNLOAD_NOUN)}
    </GrButton>
  );
}
